










































import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { ILogwork } from '@/lib/interfaces';
import TimePicker from '@/components/TimePicker.vue';
import Datepicker from 'vuejs-datepicker';
import { ru } from 'vuejs-datepicker/dist/locale';
import { createLogwork, updateLogwork, getLogwork } from '@/services/api.service';

interface Timepicker {
  HH: string;
  mm: string;
}

@Component({
  components: {
    TimePicker,
    Datepicker,
  },
})
export default class LogworkEditor extends Vue {
  private ru = ru;
  private logwork: ILogwork = {
    amount: 0,
    date: new Date().toISOString(),
    _user_id: '',
    description: '',
  };

  private get amountRaw(): Timepicker {
    return {
      HH: Math.floor(this.logwork.amount / 60) + '',
      mm: (this.logwork.amount % 60) + '',
    };
  }

  private set amountRaw(value: Timepicker) {
    this.logwork.amount = +value.HH * 60 + +value.mm;
  }

  private get dateRaw(): Date {
    return new Date(this.logwork.date.split('T')[0]);
  }

  private set dateRaw(value: Date) {
    if (value) {
      this.logwork.date = value.toISOString();
    } else {
      this.logwork.date = '';
    }
  }

  public async doneLogwork() {
    this.$route.query.logwork_id
      ? await updateLogwork(this.logwork, this.$route.params.issue_id)
      : await createLogwork(this.logwork, this.$route.params.issue_id);
    this.$router.go(-1);
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    if (to.query.logwork_id) {
      const logwork: ILogwork = await getLogwork(to.params.issue_id, to.query.logwork_id as string);
      next((vm: LogworkEditor) => {
        vm.logwork = logwork;
      });
    } else {
      next();
    }
  }
}
